import { useRef } from "react";
import { IUseCachedValueProps } from "./interfaces";

/**
 * Caches the incoming `value`, but only updates it while `enableUpdate` is true.
 * @returns The cached `value`.
 */
export function useCachedValue<T>({ enableUpdate, value }: IUseCachedValueProps<T>) {
  const cachedValue = useRef<T>(value);

  // cache the value if enableUpdate is true
  if (enableUpdate) {
    cachedValue.current = value;
  }

  // return the cached value
  return {
    cachedValue: cachedValue.current
  };
}
